import React from "react";
import useRaffleState from '../../sharedState';
import { ethers } from "ethers";
import { providers } from "ethers";
import shallow from 'zustand/shallow';
import  { useNavigate } from 'react-router-dom'
import WalletConnectProvider from "@walletconnect/web3-provider";
import { InjectedConnector } from "@web3-react/injected-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import WalletConnect from "@walletconnect/client";
import QRCodeModal from "@walletconnect/qrcode-modal";

import './connectWallet.css';
import Raffle from "../../contracts/Raffle.json";
import contractAddress from "../../contracts/contract-address.json";

const NETWORK_ID = process.env.REACT_APP_NETWORK_ID;
const INFURA_ID = process.env.REACT_APP_INFURA_ID;
// This is an error code that indicates that the user canceled a transaction
const ERROR_CODE_TX_REJECTED_BY_USER = 4001;

export function ConnectWallet() {
  const {selectedAddress} = useRaffleState((state) => ({selectedAddress: state.selectedAddress}), shallow);
  const {registered} = useRaffleState((state) => ({registered: state.registered}), shallow);
  const {transactionError} = useRaffleState((state) => ({transactionError: state.transactionError}), shallow);
  const navigate = useNavigate();

  async function initializeEthers() {
    // We first initialize ethers by creating a provider using window.ethereum
    // const provider = new ethers.providers.Web3Provider(window.ethereum);
    // const wcProvider = new WalletConnectProvider({
    //   rpc: {
    //     3: "https://ropsten.infura.io/v3/3c87c180a2ec455ba7a8d8ed0477cd08",
    //   },
    //   qrcode: true,
    //   bridge: "https://bridge.walletconnect.org",
    // });
    // await wcProvider.enable();
    const Injected = new InjectedConnector({
      supportedChainIds: [NETWORK_ID]
    });
    const provider = new providers.Web3Provider(await Injected.getProvider());
    // Then, we initialize the contract using that provider and the token's
    // artifact. You can do this same thing with your contracts.
    const raffle = new ethers.Contract(
      contractAddress.Raffle,
      Raffle.abi,
      provider.getSigner()
    );
    console.log("provider");
    return { provider, raffle }
  }

  async function initializeWallet(selectedAddress) {
    // This method initializes the dapp
    // Then, we initialize ethers, fetch the token's data, and start polling
    // for the user's balance.

    // Fetching the token data and the user's balance are specific to this
    // sample project, but you can reuse the same initialization pattern.
    const { provider, raffle } = await initializeEthers();
    const enrolled = await raffle.isWalletEnrolled(selectedAddress);
    var isRegistered = false;
    if (enrolled) {
      isRegistered = true;
    }

    useRaffleState.setState({
      selectedAddress,
      raffle,
      provider,
      registered: isRegistered,
    });
  }

  function resetState() {
    useRaffleState.setState({
      // The user's address and balance
      selectedAddress: undefined,
      // The ID about transactions being sent, and any possible error with them
      txBeingSent: undefined,
      transactionError: undefined,
      networkError: undefined,
      pollDataInterval: undefined,
      raffle: undefined,
      provider: undefined,
      registered: undefined,
    });
  };

  function _checkNetwork() {
    if (window.ethereum.networkVersion === NETWORK_ID) {
      return true;
    }
    useRaffleState.setState({networkError: 'Please connect Metamask to Ropsten Network'});

    return false;
  };

  async function connectWallet() {
    // This method is run when the user clicks the Connect. It connects the
    // dapp to the user's wallet, and initializes it.

    // To connect to the user's wallet, we have to run this method.
    // It returns a promise that will resolve to the user's address.
    const [userAddress] = await window.ethereum.request({ method: 'eth_requestAccounts' });

    // Once we have the address, we can initialize the application.

    // First we check the network
    if (!_checkNetwork()) {
      return;
    }
    // We first store the user's address in the component's state
    await initializeWallet(userAddress);

    // We reinitialize it whenever the user changes their account.
    window.ethereum.on("accountsChanged", async ([newAddress]) => {
      // `accountsChanged` event can be triggered with an undefined newAddress.
      // This happens when the user removes the Dapp from the "Connected
      // list of sites allowed access to your addresses" (Metamask > Settings > Connections)
      // To avoid errors, we reset the dapp state 
      if (newAddress === undefined) {
        return resetState();
      }
      // useRaffleState.setState((prev) => ({ ...prev, selectedAddress: newAddress }));
      await initializeWallet(newAddress);
    });
    
    // We reset the dapp state if the network is changed
    window.ethereum.on("chainChanged", ([networkId]) => {
      resetState();
    });
  }

  async function enterRaffle(e) {
    e.preventDefault();
    console.log("enter raffle");
    var formData = new FormData(e.target.form);
    var email;
    for (const [key, value] of formData) {
      switch(key) {
        case "email":
          email = value;
          break;
        default:
          email = value;
      };
    };
    const raffle = useRaffleState.getState()['raffle'];
    try {
      const tx = await raffle.enterRaffle();
      // We use .wait() to wait for the transaction to be mined. This method
      // returns the transaction's receipt.
      const receipt = await tx.wait();
  
      // The receipt, contains a status flag, which is 0 to indicate an error.
      if (receipt.status === 0) {
        // We can't know the exact error that made the transaction fail when it
        // was mined, so we throw an error.
        throw new Error("Registration failed");
      }
      useRaffleState.setState({registered: true});
    } catch (error) {
      // We check the error code to see if this error was produced because the
      // user rejected a tx. If that's the case, we do nothing.
      // if (error.code === "ACTION_REJECTED") {
      //   navigate('/sc-event');
      // }
  
      // Other errors are logged and stored in the Dapp's state. This is used to
      // show them to the user, and for debugging.
      useRaffleState.setState({transactionError: error});
    } finally {
      window.location.reload();
    };
  };

  function isMobileDevice() {
    return 'ontouchstart' in window || 'onmsgesturechange' in window;
  };

  if (!selectedAddress) {
    if (isMobileDevice()) {
      const dappUrl = window.location.hostname;
      const metamaskAppDeepLink = "https://metamask.app.link/dapp/" + dappUrl;
      return (
        <a href={metamaskAppDeepLink}>
           <button className="primary-btn">
             Connect Wallet
           </button>
        </a>
      );
    };
    return (
      <button
        type='button' className='primary-btn'
        onClick={connectWallet}
      >
        Connect Wallet
      </button>
    );
  }
  if (registered) {
    return (
      <div className="raffle-text-container">
        <h2 style={{fontSize:"16px"}}>You are registered with the wallet:&nbsp;&nbsp;&nbsp; {selectedAddress.slice(0, 5)}...{selectedAddress.substring(selectedAddress.length - 4)}</h2>
      </div>
    )
  }
  return (
    <div>
      <div className="raffle-text-container">
        <h2 style={{fontSize:"16px"}}>Wallet:&nbsp;&nbsp;&nbsp; {selectedAddress.slice(0, 5)}...{selectedAddress.substring(selectedAddress.length - 4)}</h2>
      </div>
      <br/>
      <form id="my-form" name="form-components" onSubmit={enterRaffle}>
        <input type="text" id="email" name="email" placeholder='Your Email' required={true} />
        <button type="submit" className="register" onClick={(e) => {
          e.preventDefault(e);
          enterRaffle(e);
        }}>Register!</button>
      </form>
    </div>
  )
}
